/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const stuckClass = 'js__header__stuck';
  const stickyEnterClass = 'is-sticky-enter';
  const stickyActiveClass = 'is-sticky-active';
  const scrollLockAttribute = 'data-scroll-locked';
  const scrollLockScrollableSelector = '[data-scroll-lock-scrollable]';

  const allowTouchMove = (el) => {
    if (!el) return false;
    if (el.tagName === 'TEXTAREA') return true;
    if (typeof el.closest === 'function') return Boolean(el.closest(scrollLockScrollableSelector));

    let node = el;
    while (node) {
      if (node.getAttribute && node.getAttribute('data-scroll-lock-scrollable') !== null) return true;
      node = node.parentNode;
    }
    return false;
  };

  window.addEventListener('theme:scroll:lock', (e) => {
    const ScrollLock = window.themeVendor?.ScrollLock;
    if (!ScrollLock || typeof ScrollLock.disablePageScroll !== 'function') return;

    setTimeout(() => {
      if (typeof ScrollLock.clearQueueScrollLocks === 'function') {
        ScrollLock.clearQueueScrollLocks();
      }

      ScrollLock.disablePageScroll(e?.detail, { allowTouchMove });
    }, 0);
  });

  let headerDrawerScrollY = 0;
  let headerDrawerBodyFixed = false;

  const isHeaderDrawer = (node) => {
    if (!node || !node.classList) return false;
    return node.classList.contains('drawer--header') && node.getAttribute('data-drawer') === 'hamburger';
  };

  const setBodyFixed = () => {
    if (headerDrawerBodyFixed) return;
    headerDrawerBodyFixed = true;
    headerDrawerScrollY = window.scrollY || 0;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${headerDrawerScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  const unsetBodyFixed = () => {
    if (!headerDrawerBodyFixed) return;
    headerDrawerBodyFixed = false;

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(0, headerDrawerScrollY);
    headerDrawerScrollY = 0;
  };

  document.addEventListener('theme:drawer:open', (e) => {
    if (!isHeaderDrawer(e.target)) return;

    setBodyFixed();

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    }, 0);
  });

  document.addEventListener('theme:drawer:close', (e) => {
    if (!isHeaderDrawer(e.target)) return;
    unsetBodyFixed();
  });

  document.addEventListener('change', (e) => {
    const target = e.target;
    if (!target || typeof target.matches !== 'function') return;
    if (!target.matches('.collection__sidebar__sort-select')) return;
    target.dispatchEvent(new Event('input', { bubbles: true }));
  });

  const getEls = () => {
    const wrapper = document.querySelector('[data-header-wrapper]');
    if (!wrapper) return null;
    const pageHeader = wrapper.closest('.page-header');
    const backfill = document.querySelector('[data-header-backfill]');
    return { wrapper, pageHeader, backfill };
  };

  const state = {
    ticking: false,
    headerOffset: 0,
    isStuck: false,
    stickyDelay: 200,
    mobileStickyHeight: 70,
    nonStickyHeight: 0,
  };

  const updateOffset = () => {
    const els = getEls();
    if (!els) return;
    const { wrapper } = els;
    const rect = wrapper.getBoundingClientRect();
    state.headerOffset = rect.top + window.scrollY;

    if (!wrapper.classList.contains(stickyActiveClass) && wrapper.offsetHeight > 0) {
      state.nonStickyHeight = wrapper.offsetHeight;
    }

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile && !wrapper.classList.contains(stickyActiveClass) && wrapper.offsetHeight > 0) {
      state.mobileStickyHeight = wrapper.offsetHeight;
    }
  };

  const updateBackfill = () => {
    const els = getEls();
    if (!els) return;
    const { wrapper, backfill } = els;
    if (!backfill) return;
    if (wrapper.classList.contains(stickyActiveClass)) {
      const height = state.nonStickyHeight || wrapper.offsetHeight || 0;
      if (height > 0) backfill.style.height = `${height}px`;
    }
  };

  const setStuck = (stuck) => {
    const els = getEls();
    if (!els) return;
    const { wrapper, pageHeader, backfill } = els;

    if (stuck) {
      if (backfill) {
        const height = state.nonStickyHeight || wrapper.offsetHeight || 0;
        if (height > 0) backfill.style.height = `${height}px`;
      }
      wrapper.classList.add(stuckClass);
      wrapper.classList.add(stickyEnterClass);
      wrapper.classList.add(stickyActiveClass);
      if (pageHeader) pageHeader.classList.add(stickyActiveClass);
      state.isStuck = true;

      requestAnimationFrame(() => {
        wrapper.classList.remove(stickyEnterClass);
      });
    } else {
      if (document.documentElement.hasAttribute(scrollLockAttribute)) return;
      wrapper.classList.remove(stickyEnterClass);
      wrapper.classList.remove(stickyActiveClass);
      wrapper.classList.remove(stuckClass);
      if (pageHeader) pageHeader.classList.remove(stickyActiveClass);
      state.isStuck = false;
      if (backfill) {
        requestAnimationFrame(() => {
          if (!wrapper.classList.contains(stickyActiveClass)) backfill.style.height = '';
        });
      }
    }

    updateBackfill();
  };

  const getTransparentThreshold = (wrapper) => {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) return state.headerOffset + (state.mobileStickyHeight || wrapper.offsetHeight || 0);
    return state.headerOffset + state.stickyDelay;
  };

  const onScrollTransparentSticky = () => {
    const preEls = getEls();
    if (preEls) {
      const threshold = getTransparentThreshold(preEls.wrapper);
      if (window.scrollY <= threshold && preEls.wrapper.classList.contains(stuckClass)) {
        preEls.wrapper.classList.remove(stuckClass);
      }
    }

    if (state.ticking) return;
    state.ticking = true;

    requestAnimationFrame(() => {
      state.ticking = false;
      const els = getEls();
      if (!els) return;
      const { wrapper } = els;

      const pos = window.scrollY;
      const threshold = getTransparentThreshold(wrapper);

      if (pos <= threshold) {
        wrapper.classList.remove(stuckClass);
        if (state.isStuck) setStuck(false);
        return;
      }

      if (!wrapper.classList.contains(stuckClass)) wrapper.classList.add(stuckClass);
      if (!state.isStuck) setStuck(true);
    });
  };

  const onScroll = () => {
    if (state.ticking) return;
    state.ticking = true;

    requestAnimationFrame(() => {
      state.ticking = false;
      const pos = window.scrollY;
      const els = getEls();
      if (!els) return;
      const { wrapper } = els;
      const headerHeight = state.nonStickyHeight || wrapper.offsetHeight || 0;
      const thresholdOn = state.headerOffset + state.stickyDelay;
      const thresholdOff = thresholdOn - (headerHeight || 0);

      if (!state.isStuck && pos <= thresholdOn && wrapper.classList.contains(stuckClass)) wrapper.classList.remove(stuckClass);

      if (!state.isStuck && pos > thresholdOn) setStuck(true);
      if (state.isStuck && pos <= thresholdOff) setStuck(false);
    });
  };

  const init = () => {
    const els = getEls();
    if (!els) return;
    if (!els.wrapper.hasAttribute('data-header-sticky')) return;
    updateOffset();
    updateBackfill();
    const isTransparent = els.wrapper.hasAttribute('data-header-transparent');

    if (isTransparent) {
      onScrollTransparentSticky();
      window.addEventListener('scroll', onScrollTransparentSticky, { passive: true });
    } else {
      const thresholdOn = state.headerOffset + state.stickyDelay;
      if (window.scrollY > thresholdOn) setStuck(true);
      else setStuck(false);
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    window.addEventListener('resize', () => {
      updateOffset();
      updateBackfill();
      if (isTransparent) onScrollTransparentSticky();
      else onScroll();
    });
    document.addEventListener('shopify:section:load', () => {
      updateOffset();
      updateBackfill();
      if (isTransparent) onScrollTransparentSticky();
      else onScroll();
    });
    document.addEventListener('shopify:section:unload', () => {
      updateOffset();
      updateBackfill();
      if (isTransparent) onScrollTransparentSticky();
      else onScroll();
    });
  };

  const initMobileTransparentLogoOnly = () => {
    const wrapper = document.querySelector('[data-header-wrapper][data-mobile-transparent-logo-only]');
    if (!wrapper) return;
    const hasSticky = wrapper.hasAttribute('data-header-sticky');

    const mql = window.matchMedia('(max-width: 749px)');
    let ticking = false;

    const apply = () => {
      if (!mql.matches) {
        wrapper.classList.remove('is-mobile-transparent-logo-only');
        return;
      }

      if (hasSticky) {
        if (wrapper.classList.contains(stickyActiveClass)) wrapper.classList.remove('is-mobile-transparent-logo-only');
        else wrapper.classList.add('is-mobile-transparent-logo-only');
      } else {
        if (window.scrollY <= 8) wrapper.classList.add('is-mobile-transparent-logo-only');
        else wrapper.classList.remove('is-mobile-transparent-logo-only');
      }
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        apply();
      });
    };

    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', apply, { passive: true });

    if (typeof mql.addEventListener === 'function') mql.addEventListener('change', apply);
    else if (typeof mql.addListener === 'function') mql.addListener(apply);

    document.addEventListener('shopify:section:load', apply);
    document.addEventListener('shopify:section:unload', apply);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      initMobileTransparentLogoOnly();
    });
  } else {
    init();
    initMobileTransparentLogoOnly();
  }

const initProductMediaSlideAnimation = () => {
    const supportsAnimation = typeof Element !== 'undefined' && Element.prototype && typeof Element.prototype.animate === 'function';
    if (!supportsAnimation) return;

    document.querySelectorAll('product-images').forEach((productImages) => {
      if (productImages.dataset.mediaSlideAnimInit === 'true') return;
      productImages.dataset.mediaSlideAnimInit = 'true';

      const getSlides = () => Array.from(productImages.querySelectorAll('[data-image-id]'));
      const getActiveMediaId = () => productImages.getAttribute('data-active-media');

      const findIndexByMediaId = (mediaId) => {
        const slides = getSlides();
        return slides.findIndex((el) => el.getAttribute('data-media-id') === mediaId);
      };

      const cleanupOverrides = (els) => {
        els.forEach((el) => {
          if (!el) return;
          if (el._mediaSlideInline) {
            el.removeAttribute('style');
            delete el._mediaSlideInline;
          }
          el.querySelectorAll('figure').forEach((f) => {
            if (f._mediaSlideInline) {
              f.style.contentVisibility = '';
              delete f._mediaSlideInline;
            }
          });
          el.querySelectorAll('img').forEach((img) => {
            if (img._mediaSlideInline) {
              img.style.display = '';
              delete img._mediaSlideInline;
            }
          });
        });
      };

      const animateSwitch = (fromId, toId) => {
        const slidesEl = productImages.querySelector('[data-product-media-list]');
        if (!slidesEl) return;

        const slides = getSlides();
        const fromIndex = findIndexByMediaId(fromId);
        const toIndex = findIndexByMediaId(toId);
        if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return;

        const fromSlide = slides[fromIndex];
        const toSlide = slides[toIndex];

        if (productImages._mediaSlideAnimations) {
          productImages._mediaSlideAnimations.forEach((a) => {
            try { a.cancel(); } catch (e) {}
          });
        }

        cleanupOverrides([fromSlide, toSlide]);

        const direction = toIndex > fromIndex ? 1 : -1;
        const distance = 64;
        const duration = 520;
        const easing = 'cubic-bezier(0.4, 0, 0.2, 1)';

        [fromSlide, toSlide].forEach((el) => {
          if (!el) return;
          el._mediaSlideInline = true;
          el.style.position = 'absolute';
          el.style.top = '0';
          el.style.left = '0';
          el.style.right = '0';
          el.style.width = '100%';
        });

        toSlide.style.zIndex = '2';
        fromSlide.style.zIndex = '1';

        [fromSlide, toSlide].forEach((el) => {
          el.querySelectorAll('figure').forEach((f) => {
            f._mediaSlideInline = true;
            f.style.contentVisibility = 'visible';
          });
          el.querySelectorAll('img').forEach((img) => {
            img._mediaSlideInline = true;
            img.style.display = 'block';
          });
        });

        const outAnim = fromSlide.animate(
          [{ transform: 'translateX(0px)', opacity: 1 }, { transform: `translateX(${direction * -distance}px)`, opacity: 0 }],
          { duration, easing, fill: 'both' }
        );
        const inAnim = toSlide.animate(
          [{ transform: `translateX(${direction * distance}px)`, opacity: 0 }, { transform: 'translateX(0px)', opacity: 1 }],
          { duration, easing, fill: 'both' }
        );

        productImages._mediaSlideAnimations = [outAnim, inAnim];

        Promise.allSettled([outAnim.finished, inAnim.finished]).then(() => {
          cleanupOverrides([fromSlide, toSlide]);
          try { fromSlide.style.zIndex = ''; } catch (e) {}
          try { toSlide.style.zIndex = ''; } catch (e) {}
        });
      };

      productImages.addEventListener(
        'theme:media:select',
        (e) => {
          if (!e || !e.detail || !e.detail.id) return;

          const isMobile = (window.innerWidth || document.documentElement.clientWidth || 0) < 750;
          const thumbsMode = isMobile
            ? productImages.classList.contains('product__images--mobile-thumbs')
            : productImages.classList.contains('product__images--thumbs');

          if (!thumbsMode) return;

          const fromId = getActiveMediaId();
          const toId = e.detail.id;
          if (!fromId || !toId || fromId === toId) return;

          requestAnimationFrame(() => {
            animateSwitch(fromId, toId);
          });
        },
        { capture: true }
      );
    });
  };

  const initCustom = () => {
    initProductMediaSlideAnimation();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustom);
  } else {
    initCustom();
  }
  document.addEventListener('shopify:section:load', initCustom);




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
